import { useEffect, useState, useRef } from "react";
import Api from "../../../services/api.service";
import { useTranslation } from "react-i18next";
import Slider from "react-slick";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft, faChevronRight } from "@fortawesome/free-solid-svg-icons";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import H2 from "../../../components/Titles/h2";
import Link from "../../../components/Links/link";

export default function GoogleTestimonials({ title }) {
    const [reviews, setReviews] = useState([]);
    const [showOriginal, setShowOriginal] = useState({});
    const sliderRef = useRef(null);
    const { t, i18n } = useTranslation();

    useEffect(() => {
        async function fetchReviews() {
            try {
                const response = await Api.getTestimonials(i18n.language);
                if (response.data?.result?.reviews) {
                    setReviews(response.data.result.reviews);
                }
            } catch (error) {
                console.error("Erreur lors de la récupération des avis :", error);
            }
        }

        fetchReviews();
    }, [i18n.language]);

    const renderStars = (rating) => {
        return (
            <div className="text-yellow-400 text-lg mb-2">
                {Array.from({ length: 5 }, (_, i) => (
                    <span key={i}>{i < rating ? '★' : '☆'}</span>
                ))}
            </div>
        );
    };

    const toggleOriginal = (index) => {
        setShowOriginal(prev => ({
            ...prev,
            [index]: !prev[index]
        }));
    };

    const settings = {
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: true,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1
                }
            },
            {
                breakpoint: 9999,
                settings: {
                    slidesToShow: 2
                }
            }
        ]
    };

    const goToNextSlide = () => {
        sliderRef.current?.slickNext();
    };

    const goToPrevSlide = () => {
        sliderRef.current?.slickPrev();
    };

    return (
        <div className="w-full bg-testimonials p-8 md:p-20">
            <div className="max-w-[1080px] text-center m-auto">
                <div className="w-full relative">
                    <H2 title={title} className="mb-6 md:mb-14" />

                    <div className="relative">
                        <Slider ref={sliderRef} {...settings}>
                            {reviews.map((review, index) => (
                                <Link link="https://www.google.com/search?sca_esv=02467373b682e586&rlz=1C1CHBF_deDE1102DE1102&tbm=lcl&q=L%27Artbanne+Avis&rflfq=1&num=20&stick=H4sIAAAAAAAAAONgkxIxNDI0sbA0NzQ1NzczMrIwNgPyNzAyvmLk91F3LCpJSszLS1VwLMssXsSKLgIAT4J5sD8AAAA&rldimm=12148971577622836214&hl=fr-FR&sa=X&ved=2ahUKEwjaoeyB8vyMAxXVQ6QEHbbbIk0Q9fQKegQITBAF&biw=2560&bih=1271&dpr=1#lkt=LocalPoiReviews" disableHoverEffect={true} externalLink={true} key={index}>
                                    <div className="px-4">
                                        <div className="bg-white p-6 rounded-lg shadow-md h-full flex flex-col justify-between max-w-xl mx-auto">
                                            <div className="flex items-center mb-4">
                                                <img
                                                    src={review.profile_photo_url}
                                                    alt={review.author_name}
                                                    className="w-12 h-12 rounded-full mr-4"
                                                />
                                                <div className="text-left">
                                                    <h3 className="font-semibold">{review.author_name}</h3>
                                                    <p className="text-sm text-gray-500">{review.relative_time_description}</p>
                                                    {renderStars(review.rating)}
                                                </div>
                                            </div>
                                            <div
                                                className="text-gray-700 text-left"
                                                dangerouslySetInnerHTML={{
                                                    __html: review.original && showOriginal[index] ? review.original : review.text
                                                }}
                                            />
                                            <div className="text-left">
                                                {review.translated && (
                                                    <button
                                                        onClick={() => toggleOriginal(index)}
                                                        className="text-gray-500 underline text-sm mt-2"
                                                    >
                                                        {showOriginal[index]
                                                            ? t('home.sectionTestimonials.translation')
                                                            : t('home.sectionTestimonials.original')
                                                        }
                                                    </button>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </Link>
                            ))}
                        </Slider>

                        {/* Flèches navigation */}
                        <div className="absolute -left-6 top-1/2 transform -translate-y-1/2 z-10">
                            <button onClick={goToPrevSlide} className="bg-gray-100 text-gray-500 py-2 px-4 rounded-full">
                                <FontAwesomeIcon icon={faChevronLeft} />
                            </button>
                        </div>
                        <div className="absolute -right-6 top-1/2 transform -translate-y-1/2 z-10">
                            <button onClick={goToNextSlide} className="bg-main text-white py-2 px-4 rounded-full">
                                <FontAwesomeIcon icon={faChevronRight} />
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}